var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBkngFailed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 422,
    height: 202
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bkng-failed_svg__a",
    x1: "100%",
    x2: "56.596%",
    y1: "49.757%",
    y2: "50.032%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF3E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF7F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bkng-failed_svg__b",
    x1: "100%",
    x2: "56.596%",
    y1: "40.543%",
    y2: "51.234%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF3E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF7F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bkng-failed_svg__c",
    x1: "-52.882%",
    x2: "78.497%",
    y1: "194.817%",
    y2: "21.805%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#376DA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#245791"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bkng-failed_svg__a)",
    d: "M232.58 5.35h14.72c18.168 0-12.249-5.184 0-5.184h66.485c62.024 0 82.89.471 55.874 5.183-27.017 4.712-23.802 1.414 24.751 0 48.554-1.413 25.843 9.732-28.968 9.732-54.81 0-207.465 3.777-178.722 0 19.162-2.518 48.054-4.724 86.677-6.618L232.58 5.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bkng-failed_svg__b)",
    d: "M.108 201.279c4.053-33.333 24.54-50 61.457-50 55.377 0 59.925-47.25 97.161-65.872 37.237-18.623 51.079 12.29 91.596-15.518 40.518-27.808 70.38-51.625 113.958-29.877 29.052 14.498 33.862 68.254 14.43 161.267H.108z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(121.566 74.859)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0F493F",
    d: "M.561 57.6h117.12v63.36a3.2 3.2 0 01-3.2 3.2H3.761a3.2 3.2 0 01-3.2-3.2V57.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.16,
    height: 93.44,
    x: 12.8,
    y: 0.402,
    fill: "#F8FCFE",
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCFD5",
    d: "M25.88 47.141h66v4h-66zm10 10.083h46v4h-46zm5 10h36v4h-36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0021B",
    d: "M117.681 57.6v63.36a3.2 3.2 0 01-3.2 3.2H3.928a.64.64 0 01-.318-1.195L117.681 57.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0021B",
    d: "M.561 57.6v63.36a3.2 3.2 0 003.2 3.2h110.553a.64.64 0 00.318-1.195L.562 57.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB2026",
    d: "M59.12 91.156l55.512 31.809a.64.64 0 01-.318 1.195H3.928a.64.64 0 01-.318-1.195l55.51-31.81z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 180.566,
    cy: 99.127,
    r: 13.6,
    fill: "url(#bkng-failed_svg__c)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(166.281 85.281)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.219,
    cy: 14.219,
    r: 14.219,
    fill: "#EB2026"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.98 7.084a.298.298 0 01.424 0l4.814 4.815 4.816-4.815a.298.298 0 01.424 0l1.896 1.896a.3.3 0 010 .424l-4.816 4.814 4.816 4.816a.3.3 0 01.043.37l-.043.054-1.896 1.896a.3.3 0 01-.424 0l-4.816-4.816-4.814 4.816a.3.3 0 01-.424 0l-1.896-1.896a.298.298 0 010-.424l4.815-4.816-4.815-4.814a.3.3 0 01-.043-.37l.043-.054z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 216.868,
    cy: 38.659,
    r: 6.2,
    stroke: "#F8FCFE",
    strokeWidth: 3
  }))));
}
export default SvgBkngFailed;